import { useTranslation } from 'react-i18next';
import { Star, Stars } from 'autogen/translation-keys/trans-website-filter';
import Icon from 'components/Icon';
import FilterListItem from 'components/List/components/FilterListItem';
import useGA4Tracking from 'modules/tracking/GA4';
import useFilters from '../../../shared/hooks/useFilters';
import type { BooleanStarFilterOptionProps } from '../shared/types';

export default function BooleanStarFilterOption({
    model: { displayName, hitCount, isDisabled, value },
    queryStringName,
    menuDisplayName
}: BooleanStarFilterOptionProps) {
    const { t } = useTranslation();
    const ga4Tracking = useGA4Tracking();
    const { togglePendingFilterByValue, isPendingFilterValueActive } = useFilters();

    if (isDisabled) return null;

    const isSelected = isPendingFilterValueActive(queryStringName, value);

    return (
        <FilterListItem.Button
            type="multi select"
            isSelected={isSelected}
            count={hitCount}
            buttonProps={{
                onClick: () => {
                    togglePendingFilterByValue(queryStringName, value);
                    ga4Tracking({
                        eventName: 'select_filter',
                        category: 'ecommerce',
                        eventParams: [
                            { param_name: 'list_name', param_value: displayName },
                            { param_name: 'filter_name', param_value: value },
                            { param_name: 'filter_list_name', param_value: menuDisplayName }
                        ]
                    });
                }
            }}
            BeforeRenderer={() => <Icon type="StarFilled" size={24} />}
        >
            {displayName} {t(Number(value) === 1 ? Star : Stars)}
        </FilterListItem.Button>
    );
}
